import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import UserService from "../../apiServices/UserService";
import BottomPanel from "../../components/BottomPanel";
import { TextField } from 'react-md';
import { notification } from 'antd';

class ChangePassword extends Component {

    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            current_password: '',
            new_password: '',
            confirm_new_password: '',
            hiddenBtn: false,
        };
    }

    componentDidMount() {
    }

    formSubmit = () => {
        if (this.state.current_password === ''){
            notification['error']({
                message: 'Bạn chưa nhập Mật khẩu  cũ',
                description: '',
            });
        }else if (this.state.new_password === ''){
            notification['error']({
                message: 'Bạn chưa nhập Mật khẩu mới',
                description: '',
            });
        }else if (this.state.confirm_new_password === ''){
            notification['error']({
                message: 'Bạn chưa nhập xác nhận Mật khẩu mới',
                description: '',
            });
        }else{
            if(this.state.new_password !== this.state.confirm_new_password){
                notification['error']({
                    message: 'Mật khẩu mới và Xác nhận mật khẩu phải giống nhau',
                    description: '',
                });
            }else{
                UserService.changePassword({
                    'password': this.state.current_password,
                    'new_password': this.state.new_password
                }).then(response => {
                    if(response.code===0){
                        notification['success']({
                            message: 'Đổi mật khẩu thành công',
                            description: '',
                        });
                        this.setState({hiddenBtn: true});
                        this.props.history.push('/');
                    }else{
                        notification['error']({
                            message: 'Đổi mật khẩu không thành công, vui lòng thử lại',
                            description: '',
                        });
                    }
                });
            }
        }
    };

    render() {
        return (
            <div className='App-block'>
                <DefaultLayout {...this.props} title="Đổi mật khẩu" classNameContent="bgWhite" page_type={1} hiddenFt={true}>
                    <div className="wrap-content">
                        <TextField
                            id="current-pwd"
                            label="Mật khẩu cũ"
                            className="md-cell md-cell--12"
                            type='password'
                            onChange={e => this.setState({current_password: e})}
                        />

                        <TextField
                            id="new-password"
                            label="Mật khẩu mới"
                            className="md-cell md-cell--12"
                            type='password'
                            onChange={e => this.setState({new_password: e})}
                        />

                        <TextField
                            id="confirm-new-pwd"
                            label="Xác nhận mật khẩu mới"
                            className="md-cell md-cell--12"
                            type='password'
                            onChange={e => this.setState({confirm_new_password: e})}
                        />
                    </div>
                </DefaultLayout>
                <BottomPanel handleClick={this.formSubmit} hidden={this.state.hiddenBtn} title={"Cập nhật thông tin"} actionType='summit'/>
            </div>
        )
    }
}

export default (withTranslation())(ChangePassword);
